<div class="w-full h-full bg-[#232323] px-6 py-8 overflow-auto">
  <!-- Header -->
  <div class="flex items-center justify-between mb-6">
    <div>
      <h2 class="text-2xl font-bold text-white">Comunicados</h2>
      <p class="text-white/60 text-sm mt-1">
        {{ isVisualizacaoMode ? 'Visualize os comunicados das imobiliárias' : 'Gerencie os comunicados enviados e recebidos' }}
      </p>
    </div>
    <button
      *ngIf="podeCriarComunicado"
      mat-flat-button
      color="primary"
      class="!bg-[#E4811E] !text-black font-semibold"
      (click)="abrirForm()"
    >
      <mat-icon class="mr-2">add</mat-icon>
      Novo Comunicado
    </button>
  </div>

  <!-- Autocomplete de Imobiliárias (para ADM_SISTEMA e PARCEIRO) -->
  <div *ngIf="isVisualizacaoMode" class="mb-6">
    <mat-form-field appearance="outline" class="w-full max-w-md">
      <mat-label>Selecione uma Imobiliária</mat-label>
      <input
        matInput
        [formControl]="imobiliariaCtrl"
        [matAutocomplete]="autoImob"
        (input)="filterImobiliarias($event)"
        placeholder="Digite para buscar..."
      />
      <mat-icon matSuffix class="text-white/50">search</mat-icon>
      <mat-autocomplete
        #autoImob="matAutocomplete"
        [displayWith]="displayImobiliariaFn"
        (optionSelected)="onImobiliariaSelected($event.option.value)"
      >
        <mat-option *ngFor="let imob of filteredImobiliarias" [value]="imob">
          {{ imob.nome }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <p *ngIf="selectedImobiliariaName" class="text-white/60 text-sm mt-2">
      Exibindo comunicados da imobiliária: <span class="text-[#E4811E] font-medium">{{ selectedImobiliariaName }}</span>
    </p>
  </div>

  <!-- Filtro de Resultado -->
  <div class="mb-4">
    <div class="bg-zinc-800 rounded-lg border border-zinc-700 px-4 py-2 flex items-center max-w-md">
      <mat-icon class="text-white/70">search</mat-icon>
      <input [formControl]="resultFilter" class="pl-4 pr-2 py-1 bg-transparent w-full outline-none text-white placeholder:text-white/50"
             placeholder="Filtrar no resultado..." type="search" />
    </div>
  </div>

  <!-- Tabs (para ADM_IMOBILIARIA e USUARIO_IMOBILIARIA) -->
  <div *ngIf="!isVisualizacaoMode" class="flex gap-4 mb-6 border-b border-zinc-700">
    <button
      class="px-4 py-3 text-sm font-medium transition-colors relative"
      [ngClass]="{'text-[#E4811E]': activeTab === 'recebidos', 'text-white/60': activeTab !== 'recebidos'}"
      (click)="activeTab = 'recebidos'"
    >
      Comunicados Recebidos
      <span
        *ngIf="comunicadosRecebidos.length"
        class="ml-2 px-2 py-0.5 text-xs rounded-full"
        [ngClass]="{'bg-[#E4811E] text-black': activeTab === 'recebidos', 'bg-zinc-700 text-white/60': activeTab !== 'recebidos'}"
      >
        {{ comunicadosRecebidos.length }}
      </span>
      <div
        *ngIf="activeTab === 'recebidos'"
        class="absolute bottom-0 left-0 right-0 h-0.5 bg-[#E4811E]"
      ></div>
    </button>
    <!-- Tab de enviados apenas para ADM_IMOBILIARIA -->
    <button
      *ngIf="perfilId === 2"
      class="px-4 py-3 text-sm font-medium transition-colors relative"
      [ngClass]="{'text-[#E4811E]': activeTab === 'enviados', 'text-white/60': activeTab !== 'enviados'}"
      (click)="activeTab = 'enviados'"
    >
      Comunicados Enviados
      <span
        *ngIf="comunicadosEnviados.length"
        class="ml-2 px-2 py-0.5 text-xs rounded-full"
        [ngClass]="{'bg-[#E4811E] text-black': activeTab === 'enviados', 'bg-zinc-700 text-white/60': activeTab !== 'enviados'}"
      >
        {{ comunicadosEnviados.length }}
      </span>
      <div
        *ngIf="activeTab === 'enviados'"
        class="absolute bottom-0 left-0 right-0 h-0.5 bg-[#E4811E]"
      ></div>
    </button>
  </div>

  <!-- Tabela de TODOS os Comunicados da Imobiliária (para ADM_SISTEMA e PARCEIRO) -->
  <div *ngIf="isVisualizacaoMode && activeTab === 'todos'" class="bg-zinc-900 rounded-xl border border-zinc-800 overflow-hidden">
    <!-- Loading -->
    <div *ngIf="loadingImobiliaria" class="flex items-center justify-center py-16">
      <mat-spinner diameter="40"></mat-spinner>
    </div>

    <!-- Placeholder antes de selecionar imobiliária -->
    <div *ngIf="!loadingImobiliaria && !selectedImobiliariaName" class="flex flex-col items-center justify-center py-16 text-white/50">
      <mat-icon class="text-5xl mb-4 !w-12 !h-12">business</mat-icon>
      <p class="text-lg">Selecione uma imobiliária</p>
      <p class="text-sm mt-1">Escolha uma imobiliária no campo acima para visualizar os comunicados.</p>
    </div>

    <!-- Empty State -->
    <div *ngIf="!loadingImobiliaria && selectedImobiliariaName && filteredComunicadosImobiliaria.length === 0" class="flex flex-col items-center justify-center py-16 text-white/50">
      <mat-icon class="text-5xl mb-4 !w-12 !h-12">campaign</mat-icon>
      <p class="text-lg">Nenhum comunicado encontrado</p>
      <p class="text-sm mt-1">Esta imobiliária ainda não possui comunicados registrados.</p>
    </div>

    <!-- Table -->
    <div *ngIf="!loadingImobiliaria && filteredComunicadosImobiliaria.length > 0" class="overflow-x-auto">
    <table class="w-full min-w-[480px]">
      <thead class="bg-zinc-800/50">
        <tr>
          <th class="text-left text-xs font-semibold text-white/60 uppercase tracking-wider px-6 py-4">Origem</th>
          <th class="text-left text-xs font-semibold text-white/60 uppercase tracking-wider px-6 py-4">Título</th>
          <th class="text-left text-xs font-semibold text-white/60 uppercase tracking-wider px-6 py-4">Data de Envio</th>
          <th class="text-center text-xs font-semibold text-white/60 uppercase tracking-wider px-6 py-4">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let comunicado of filteredComunicadosImobiliaria"
          class="border-t border-zinc-800 hover:bg-zinc-800/50 transition-colors"
        >
          <td class="px-6 py-4">
            <span [ngClass]="getOrigemClass(comunicado)">
              {{ getOrigem(comunicado) }}
            </span>
          </td>
          <td class="px-6 py-4">
            <p class="text-white font-medium">{{ comunicado.titulo }}</p>
          </td>
          <td class="px-6 py-4 text-white/60 text-sm whitespace-nowrap">
            {{ comunicado.dataEnvio | date:'dd/MM/yyyy HH:mm' }}
          </td>
          <td class="px-6 py-4 text-center">
            <button
              mat-icon-button
              class="!text-white/70 hover:!text-white"
              (click)="abrirDetalhe(comunicado)"
            >
              <mat-icon>visibility</mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    </div>
  </div>

  <!-- Tabela de Comunicados Recebidos (para ADM_IMOBILIARIA e USUARIO_IMOBILIARIA) -->
  <div *ngIf="!isVisualizacaoMode && activeTab === 'recebidos'" class="bg-zinc-900 rounded-xl border border-zinc-800 overflow-hidden">
    <!-- Loading -->
    <div *ngIf="loadingRecebidos" class="flex items-center justify-center py-16">
      <mat-spinner diameter="40"></mat-spinner>
    </div>

    <!-- Empty State -->
    <div *ngIf="!loadingRecebidos && filteredComunicadosRecebidos.length === 0" class="flex flex-col items-center justify-center py-16 text-white/50">
      <mat-icon class="text-5xl mb-4 !w-12 !h-12">inbox</mat-icon>
      <p class="text-lg">Nenhum comunicado recebido</p>
      <p class="text-sm mt-1">Quando você receber um comunicado, ele aparecerá aqui.</p>
    </div>

    <!-- Table -->
    <div *ngIf="!loadingRecebidos && filteredComunicadosRecebidos.length > 0" class="overflow-x-auto">
    <table class="w-full min-w-[520px]">
      <thead class="bg-zinc-800/50">
        <tr>
          <th class="text-left text-xs font-semibold text-white/60 uppercase tracking-wider px-6 py-4">Origem</th>
          <th class="text-left text-xs font-semibold text-white/60 uppercase tracking-wider px-6 py-4">Título</th>
          <th class="text-left text-xs font-semibold text-white/60 uppercase tracking-wider px-6 py-4">Data de Envio</th>
          <th class="text-center text-xs font-semibold text-white/60 uppercase tracking-wider px-6 py-4">Visualizado</th>
          <th class="text-center text-xs font-semibold text-white/60 uppercase tracking-wider px-6 py-4">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let comunicado of filteredComunicadosRecebidos"
          class="border-t border-zinc-800 hover:bg-zinc-800/50 transition-colors"
          [ngClass]="{'bg-zinc-800/30': !comunicado.visualizadoFlag}"
        >
          <td class="px-6 py-4">
            <span [ngClass]="getOrigemClass(comunicado)">
              {{ getOrigem(comunicado) }}
            </span>
          </td>
          <td class="px-6 py-4">
            <p class="text-white font-medium" [ngClass]="{'font-bold': !comunicado.visualizadoFlag}">
              {{ comunicado.titulo }}
            </p>
          </td>
          <td class="px-6 py-4 text-white/60 text-sm whitespace-nowrap">
            {{ comunicado.dataEnvio | date:'dd/MM/yyyy HH:mm' }}
          </td>
          <td class="px-6 py-4 text-center">
            <mat-icon
              [class]="comunicado.visualizadoFlag ? 'text-green-400' : 'text-red-400'"
            >
              {{ comunicado.visualizadoFlag ? 'check_circle' : 'cancel' }}
            </mat-icon>
          </td>
          <td class="px-6 py-4 text-center">
            <button
              mat-icon-button
              class="!text-white/70 hover:!text-white"
              (click)="abrirDetalhe(comunicado)"
            >
              <mat-icon>visibility</mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    </div>
  </div>

  <!-- Tabela de Comunicados Enviados (apenas para ADM_IMOBILIARIA) -->
  <div *ngIf="!isVisualizacaoMode && activeTab === 'enviados'" class="bg-zinc-900 rounded-xl border border-zinc-800 overflow-hidden">
    <!-- Loading -->
    <div *ngIf="loadingEnviados" class="flex items-center justify-center py-16">
      <mat-spinner diameter="40"></mat-spinner>
    </div>

    <!-- Empty State -->
    <div *ngIf="!loadingEnviados && filteredComunicadosEnviados.length === 0" class="flex flex-col items-center justify-center py-16 text-white/50">
      <mat-icon class="text-5xl mb-4 !w-12 !h-12">send</mat-icon>
      <p class="text-lg">Nenhum comunicado enviado</p>
      <p class="text-sm mt-1">Quando você enviar um comunicado, ele aparecerá aqui.</p>
    </div>

    <!-- Table -->
    <div *ngIf="!loadingEnviados && filteredComunicadosEnviados.length > 0" class="overflow-x-auto">
    <table class="w-full min-w-[480px]">
      <thead class="bg-zinc-800/50">
        <tr>
          <th class="text-left text-xs font-semibold text-white/60 uppercase tracking-wider px-6 py-4">Título</th>
          <th class="text-left text-xs font-semibold text-white/60 uppercase tracking-wider px-6 py-4">Destino</th>
          <th class="text-left text-xs font-semibold text-white/60 uppercase tracking-wider px-6 py-4">Data de Envio</th>
          <th class="text-center text-xs font-semibold text-white/60 uppercase tracking-wider px-6 py-4">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let comunicado of filteredComunicadosEnviados"
          class="border-t border-zinc-800 hover:bg-zinc-800/50 transition-colors"
        >
          <td class="px-6 py-4">
            <p class="text-white font-medium">{{ comunicado.titulo }}</p>
          </td>
          <td class="px-6 py-4">
            <span class="text-white/80">{{ comunicado.destinoDescricao || 'Todos da imobiliária' }}</span>
          </td>
          <td class="px-6 py-4 text-white/60 text-sm whitespace-nowrap">
            {{ comunicado.dataEnvio | date:'dd/MM/yyyy HH:mm' }}
          </td>
          <td class="px-6 py-4 text-center">
            <button
              mat-icon-button
              class="!text-white/70 hover:!text-white"
              (click)="abrirDetalhe(comunicado)"
            >
              <mat-icon>visibility</mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    </div>
  </div>

  <!-- Modal de Detalhes do Comunicado -->
  <div
    *ngIf="showDetalheModal && comunicadoSelecionado"
    class="fixed inset-0 bg-black/60 flex items-end sm:items-center justify-center z-50 p-0 sm:p-4"
    (click)="fecharDetalhe()"
  >
    <div
      class="bg-zinc-900 rounded-t-[20px] sm:rounded-xl border border-zinc-800 w-full max-w-2xl max-h-[92dvh] sm:max-h-[80vh] overflow-hidden modal-slide-up"
      (click)="$event.stopPropagation()"
    >
      <!-- Header do Modal -->
      <div class="flex items-center justify-between px-6 py-4 border-b border-zinc-800">
        <div>
          <h3 class="text-xl font-bold text-white">{{ comunicadoSelecionado.titulo }}</h3>
          <p class="text-white/60 text-sm mt-1">
            Enviado em {{ comunicadoSelecionado.dataEnvio | date:'dd/MM/yyyy HH:mm' }}
            <span *ngIf="comunicadoSelecionado.nomeRemetente || comunicadoSelecionado.isEdducaImob">
              por <span [ngClass]="getOrigemClass(comunicadoSelecionado)">{{ getOrigem(comunicadoSelecionado) }}</span>
            </span>
          </p>
        </div>
        <button mat-icon-button class="!text-white/70 hover:!text-white" (click)="fecharDetalhe()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <!-- Imagem (se houver) -->
      <img
        *ngIf="comunicadoSelecionado.imagemUrl"
        [src]="comunicadoSelecionado.imagemUrl"
        alt="Imagem do comunicado"
        class="w-full max-h-[40vh] object-contain border-b border-zinc-800"
      />

      <!-- Conteúdo do Modal -->
      <div class="px-6 py-4 overflow-auto max-h-[40vh]">
        <p class="text-white/80 whitespace-pre-wrap">{{ comunicadoSelecionado.textoComunicado }}</p>
      </div>

      <!-- Footer do Modal -->
      <div class="flex justify-end px-6 py-4 border-t border-zinc-800">
        <button
          mat-flat-button
          class="!bg-[#E4811E] !text-black font-semibold"
          (click)="fecharDetalhe()"
        >
          Fechar
        </button>
      </div>
    </div>
  </div>
</div>